var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCloseAddCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4706 22 22 17.4706 22 12C22 6.53922 17.4608 2 11.9902 2C6.52941 2 2 6.53922 2 12C2 17.4706 6.53922 22 12 22ZM11.9804 16.8824C11.4216 16.8824 11.1275 16.4804 11.1275 15.9118V12.8627H7.91177C7.33333 12.8627 6.93137 12.5588 6.93137 12.0196C6.93137 11.4608 7.31373 11.1471 7.91177 11.1471H11.1275V7.90196C11.1275 7.33333 11.4216 6.93137 11.9804 6.93137C12.5294 6.93137 12.8529 7.31373 12.8529 7.90196V11.1471H16.0784C16.6765 11.1471 17.049 11.4608 17.049 12.0196C17.049 12.5588 16.6569 12.8627 16.0784 12.8627H12.8529V15.9118C12.8529 16.5 12.5294 16.8824 11.9804 16.8824Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCloseAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-close-add-circle.4e10087ae73566b6ed268e521e816487.svg";